import { render, staticRenderFns } from "./EditClassModal.vue?vue&type=template&id=56f779b6&scoped=true&"
import script from "./EditClassModal.vue?vue&type=script&lang=ts&"
export * from "./EditClassModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f779b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tommy/Documents/BrocheBallet/studio-manager/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56f779b6')) {
      api.createRecord('56f779b6', component.options)
    } else {
      api.reload('56f779b6', component.options)
    }
    module.hot.accept("./EditClassModal.vue?vue&type=template&id=56f779b6&scoped=true&", function () {
      api.rerender('56f779b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/classes/components/EditClassModal.vue"
export default component.exports